package com.example.mystybag.sharedmodels.project.responseModels.merchant

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

/** Детайлна оценка по категория (Вкус, Качество, Свежест, Стойност). categoryKey съвпада с ключ за string resource, напр. "review_rating_taste". */
@Serializable
data class CategoryRatingResponseItem(
    val categoryKey: String = "",
    val averageRating: Double? = null
)

@Serializable
data class LocationRatingResponseItem(
    val locationId: Long? = null,
    val locationName: String? = null,
    val averageRating: Double? = null,
    val reviewCount: Int? = null,
    /** Детайлни оценки по категории: Вкус, Качество, Свежест, Стойност (categoryKey: review_rating_taste, review_rating_quality, review_rating_freshness, review_rating_value) */
    val categoryRatings: List<CategoryRatingResponseItem> = emptyList()
)

@Serializable
data class GetMerchantReputationResponseModel(
    val locationRatings: List<LocationRatingResponseItem> = emptyList(),
    val favoritesCount: Int? = null
) : BaseResponseModel()

